import React from "react";
import { SectionDefinition } from "../../../../model/service-request/section-definition";
import { DynamicFieldItem } from "../../../../model/dynamic-forms";
import DynamicField from "./DynamicFormGenerator";
import { useDynamicFormState } from "./engine/useDynamicFormState";
import styles from "./dynamic-form.module.scss";

interface DynamicFormProps {
	sectionDefinition: SectionDefinition;
	preselectedFormValues: DynamicFieldItem[];
	isSubmitted: boolean;
	onValuesChange: (values: DynamicFieldItem[]) => void;
}

const DynamicForm: React.FC<DynamicFormProps> = ({ sectionDefinition, preselectedFormValues, isSubmitted, onValuesChange }) => {
	const { values, setField, removeField } = useDynamicFormState(preselectedFormValues, onValuesChange);
	const valuesById = new Map(values.map(v => [v.fieldId, v]));

	const attributes = sectionDefinition.attributeDefinitions
		.filter(attr => attr.isEnabled !== false && attr.isHidden !== true)
		.slice()
		.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));

	return (
		<div className={styles.form}>
			{attributes.map(attribute => (
				<DynamicField
					key={attribute.id}
					attribute={attribute}
					preselectedValue={valuesById.get(attribute.id)}
					isSubmitted={isSubmitted}
					onChange={setField}
					onRemove={removeField}
				/>
			))}
		</div>
	);
};

export default DynamicForm;
